import { Component, Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TicketBatchTicket } from '../../models/entities/ticket-batch-ticket';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { ToastrService } from 'ngx-toastr';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { TicketService } from '../../services/ticket-service';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { TicketBatchTicketSpare } from '../../models/entities/ticket-batch-ticket-spare';
import { LeanConfirmationComponent } from 'src/app/tools/components/lean-confirmation/lean-confirmation.component';


@Component({
    selector: 'ticket-batch-ticket-widget',
    templateUrl: './ticket-batch-ticket-widget.component.html',
    styleUrls: ['./ticket-batch-ticket-widget.component.scss']
})

export class TicketBatchTicketWidgetComponent extends BaseWidget {
 
ticketBatchTicket : TicketBatchTicket;
assetProduct      : AssetProduct;


  constructor(
    public dialogRef: MatDialogRef<TicketBatchTicketWidgetComponent>,  @Inject(MAT_DIALOG_DATA) public modalData: any,
    protected controlTablesService  : ControlTablesService,
    protected ticketService         : TicketService,
    protected toastr                : ToastrService,
    public    leanUtilsService      : LeanUtilsService,
    protected dialog                : MatDialog) {
    super(toastr, leanUtilsService);
    if (modalData) {
        this.setBaseEntity(modalData.ticketBatchTicket);
        this.columns = modalData.columns;
    }
}


//----------------------------------------------------------------------
setEntity(ticketBatchTicket : TicketBatchTicket) {
    this.ticketBatchTicket = ticketBatchTicket;
}
getEntity(): BaseEntity {
    return  this.ticketBatchTicket;
}
saveRow(): Promise<BaseEntity> {
    throw new Error('Method not implemented.');
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
close(){
    this.dialogRef.close(null);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
deleteTicketBatchTicket(){
    let confirmationMessage = "Confirmez-vous la suppression de de ticket";
    let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}});
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.ticketService.ticketBatchTicketDelete(this.ticketBatchTicket).then(result => {
                this.showSuccessFulOperation();
                this.ticketBatchTicket.deleted = true;
                this.dialogRef.close(this.ticketBatchTicket);
              });
        }
    });
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeTicketBatchTicket(){
    this.ticketService.ticketBatchTicketClose(this.ticketBatchTicket).then(ticketBatchTicket => {
        this.showSuccessFulOperation();
        this.dialogRef.close(ticketBatchTicket);
      });
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
addAssetProduct(){
    let found : boolean = false;
    for (let ticketBatchTicketSpare of this.ticketBatchTicket.ticketBatchTicketSpares){
        if (ticketBatchTicketSpare.assetProduct.id == this.assetProduct.id) {
            found = true;
            break;
        };
    }
    if (found) return;
    let ticketBatchTicketSpare : TicketBatchTicketSpare = new TicketBatchTicketSpare();
    ticketBatchTicketSpare.edit     = true;
    ticketBatchTicketSpare.inserted = true;
    ticketBatchTicketSpare.quantity = 1;
    ticketBatchTicketSpare.assetProduct = this.assetProduct;
    this.ticketBatchTicket.ticketBatchTicketSpares.push(ticketBatchTicketSpare)
    this.ticketBatchTicket.ticketBatchTicketSpares = [...this.ticketBatchTicket.ticketBatchTicketSpares];
}
//----------------------------------------------------------------------

}
